/** Client-only keys on Functional Table rows (see Functional/Table wrapper). */
const ROW_KEYS_ALWAYS_OMIT = new Set(["rawFields", "isnewData"]);

const isRelationObject = value =>
  value !== null &&
  typeof value === "object" &&
  !(value instanceof Date) &&
  !Array.isArray(value);

const isRelationShapedRowField = (key, value) =>
  (key === "invoice" || key === "instance" || key === "type") &&
  isRelationObject(value);

const sanitiseTableRowUpdate = changedFields =>
  Object.fromEntries(
    Object.entries(changedFields || {}).filter(
      ([key, value]) =>
        !ROW_KEYS_ALWAYS_OMIT.has(key) &&
        !isRelationShapedRowField(key, value),
    ),
  );

const ROW_UPDATE_DEBOUNCE_MS = 500;

export { ROW_UPDATE_DEBOUNCE_MS, sanitiseTableRowUpdate };
